// extracted by mini-css-extract-plugin
export var banner = "_3y-0";
export var icon = "_3y-1";
export var message = "_3y-2";